import React, { FC } from "react"
import { Path, Svg, View } from "@react-pdf/renderer"

export type PdfIcon = {
    fill: string
}
const SettingsEthernet: FC<PdfIcon> = (props) => {
    const { fill } = props;
    return (
        <View style={{height: 20, width: 20}}>
            <Svg height={30} width={30}>
                <Path d="M7.77 6.76 6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12zM7 13h2v-2H7zm10-2h-2v2h2zm-6 2h2v-2h-2zm6.77-7.52-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12z" 
                    fill={fill || "currentColor"} // Set fill from props or default to 'currentColor'
                />
            </Svg>
        </View>
    )
}

export default SettingsEthernet;